module.exports = __webpack_public_path__ + "img/proctoring.5f09214c.svg";